<template>
  <nav class="site-navbar" :class="'site-navbar--' + navbarLayoutType">
    <div class="site-navbar__header">
      <h1 class="site-navbar__brand" @click="$router.push({ name: 'home' })">
        <!-- <img src="~@imgs/common/favicon.png" alt="" class="site-navbar__brand-logo"> -->
        <a class="site-navbar__brand-lg" href="javascript:;">
          <img src="~@imgs/common/logo.png.png" alt="" />
        </a>
        <a class="site-navbar__brand-mini" href="javascript:;"
          >安徽省网商协会后台管理系统</a
        >
      </h1>
    </div>
    <div class="site-navbar__body clearfix" style=" height: 62px">
      <el-menu class="site-navbar__menu" mode="horizontal">
        <el-menu-item
          class="site-navbar__switch"
          index="0"
          @click="sidebarFold = !sidebarFold"
        >
          <icon-svg name="zhedie"></icon-svg>
          <i class="bo-l"></i>
        </el-menu-item>
      </el-menu>
      <el-menu
        class="site-navbar__menu site-navbar__menu--right"
        mode="horizontal"
      >
        <el-menu-item class="site-navbar__avatar" index="4">
          <el-dropdown size="small" :show-timeout="0" placement="bottom">
            <span class="el-dropdown-link">
              数据看板
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="tohome">pvuv</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-menu-item>
        <el-menu-item class="site-navbar__avatar" index="4">
          <el-dropdown size="small" :show-timeout="0" placement="bottom">
            <span class="el-dropdown-link">
              咨询建议
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="tohomeee"
                >咨询和建议</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </el-menu-item>
        <el-menu-item class="site-navbar__avatar" index="4">
          <el-dropdown size="small" :show-timeout="0" placement="bottom">
            <span class="el-dropdown-link">
              供需对接
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="tohomee"
                >需求管理</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </el-menu-item>
        <el-menu-item class="site-navbar__avatar" index="2" @click="screen">
          <i class="el-icon-full-screen" :title="fullTitle"></i>
        </el-menu-item>
        <!-- <el-menu-item index="3" @click="$router.push({ name: 'theme' })">
          <template slot="title">
            <el-badge>
              <icon-svg name="shezhi" class="el-icon-setting"></icon-svg>
            </el-badge>
          </template>
        </el-menu-item> -->
        <el-menu-item class="site-navbar__avatar" index="4">
          <el-dropdown :show-timeout="0" placement="bottom">
            <span class="el-dropdown-link">
              <img src="~@imgs/common/avatar.png" :alt="userName" />{{
                userName
              }}
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="updatePasswordHandle()"
                >修改密码</el-dropdown-item
              >
              <el-dropdown-item @click.native="logoutHandle()"
                >退出</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </el-menu-item>
      </el-menu>
    </div>
    <!-- 弹窗, 修改密码 -->
    <update-password
      v-if="updatePassowrdVisible"
      ref="updatePassowrd"
    ></update-password>
  </nav>
</template>

<script>
import UpdatePassword from "./main-navbar-update-password";
import { clearLoginInfo } from "@/utils";
import message from "./main-message";
let flag = 0;
export default {
  data() {
    return {
      updatePassowrdVisible: false,
      fullTitle: "全屏",
    };
  },
  components: {
    UpdatePassword,
    message,
  },
  computed: {
    navbarLayoutType: {
      get() {
        return this.$store.state.common.navbarLayoutType;
      },
    },
    sidebarFold: {
      get() {
        return this.$store.state.common.sidebarFold;
      },
      set(val) {
        this.$store.commit("common/updateSidebarFold", val);
      },
    },
    mainTabs: {
      get() {
        return this.$store.state.common.mainTabs;
      },
      set(val) {
        this.$store.commit("common/updateMainTabs", val);
      },
    },
    userName: {
      get() {
        return this.$store.state.user.name;
      },
    },
    userId: {
      get() {
        return this.$store.state.user.id;
      },
    },
  },
  created() {},
  destroyed() {},
  methods: {
    tohome() {
      this.$router.replace({ name: "home" });
    },
    tohomee() {
      this.$router.replace({ name: "xuqiu", query: { id: 1 } });
    },
    tohomeee() {
      this.$router.replace({ name: "zxjy", query: { id: 1 } });
    },
    // 切换浏览器窗口大小
    screen: function () {
      if (flag === 0) {
        this.fullTitle = "退出全屏";
        this.fullScreen();
        flag = 1;
      } else {
        this.fullTitle = "全屏";
        this.exitFullScreen();
        flag = 0;
      }
    },
    // 点击放大浏览器窗口
    fullScreen: function () {
      const el = document.documentElement;
      const rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen;
      let wscript;

      if (typeof rfs !== "undefined" && rfs) {
        rfs.call(el);
        return;
      }

      if (typeof window.ActiveXObject !== "undefined") {
        wscript = window.ActiveXObject("WScript.Shell");
        if (wscript) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    // 点击还原浏览器窗口
    exitFullScreen: function () {
      const el = document;
      const cfs =
        el.cancelFullScreen ||
        el.webkitCancelFullScreen ||
        el.mozCancelFullScreen ||
        el.exitFullScreen;
      let wscript;

      if (typeof cfs !== "undefined" && cfs) {
        cfs.call(el);
        return;
      }

      if (typeof window.ActiveXObject !== "undefined") {
        wscript = window.ActiveXObject("WScript.Shell");
        if (wscript != null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    // 修改密码
    updatePasswordHandle() {
      this.updatePassowrdVisible = true;
      this.$nextTick(() => {
        this.$refs.updatePassowrd.init();
      });
    },
    // 退出
    logoutHandle() {
      this.$confirm("确定进行[退出]操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http({
            url: this.$http.adornUrl("/sys/logout"),
            method: "post",
            data: this.$http.adornData(),
          }).then(({ data }) => {
            if (data && data.code === 0) {
              clearLoginInfo();
              this.$router.push({ name: "login" });
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.site-navbar__body .clearfix {
  height: 62px !important;
}
.site-navbar {
  /* background-image: linear-gradient(90deg, #003777 0%, #0063d4 100%); */
}
.el-menu-item {
  padding: 0 10px !important;
}
.bo-l {
  width: 2px;
  border-color: #1890ff;
}
.messageHide {
  position: absolute !important;
  top: 14px !important;
  right: -20px !important;
  background: #d00 !important;
  height: 16px !important;
  line-height: 16px !important;
  font-size: 12px !important;
  -webkit-border-radius: 50px !important;
  -moz-border-radius: 50px !important;
  border-radius: 50px !important;
  padding: 0 8px !important;
  color: #fff !important;
}

.site-navbar__brand-lg img {
  width: 214px;
  height: 32px;
}
.site-navbar__brand-logo {
  height: 80%;
}
.icon-svg {
  color: white;
}

.el-icon-full-screen {
  font-size: 22px !important;
  color: white !important;
}

.el-dropdown {
  color: white;
  font-size: 14px;
}

.site-navbar__header {
  width: 250px;
}
.site-navbar__menu {
  margin: 18px 0px !important;
  border-bottom: none !important;
}

.site-navbar__brand-mini {
  font-weight: 400;
  font-size: 12px;
}

.site-navbar__switch {
  display: none;
}
.el-icon-arrow-down {
  margin-bottom: 2px;
  color: #fff;
  font-weight: 400;
  font-size: 12px;
}
</style>
